import React from "react";
import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  label: string;
  count?: number;
  navigateTo: string;
  className?: string;
  onClick?: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({
  label,
  count,
  navigateTo,
  className = "",
  onClick,
}) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={onClick || (() => navigate(navigateTo))}
      className={`text-white text-base sm:text-xl md:text-2xl font-medium flex items-center gap-1 sm:gap-2 hover:text-[#008564] transition-colors ${className}`}
    >
      {`< ${label}${count !== undefined ? ` (${count})` : ""}`}
    </button>
  );
};

export default BackButton;
